var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconExpandablePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 0a.75.75 0 01.75.75v22.5a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75V.75A.75.75 0 01.75 0h22.5zM22 2H2v20h20V2zM12 6c.552 0 1 .336 1 .75V11h4.25c.414 0 .75.448.75 1s-.336 1-.75 1H13v4.25c0 .414-.448.75-1 .75s-1-.336-1-.75V13H6.75c-.414 0-.75-.448-.75-1s.336-1 .75-1H11V6.75c0-.414.448-.75 1-.75z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconExpandablePlus;